import { DISMISS_STATE_KIND } from './DISMISS_STATE_KIND';
import type { DismissState } from './DismissState';

export const createSeenState = (firstViewedAt: number): DismissState => ({
	kind: DISMISS_STATE_KIND.SEEN,
	firstViewedAt,
});
